import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_APPROVAL, CUSTOMER_APPROVAL_SUCCESS, CUSTOMER_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* customerApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/customer-approval-request/${approval_id}/action`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CUSTOMER_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CUSTOMER_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CUSTOMER_APPROVAL_ERROR, payload: error });
  }
}

export function* watchCustomerApproval() {
  yield takeEvery(CUSTOMER_APPROVAL, customerApproval);
}

function* customerApprovalSaga() {
  yield all([fork(watchCustomerApproval)]);
}

export default customerApprovalSaga;
